import HttpService from "./http.service";

class AuthService {
  login = async (payload) => {
    const loginEndpoint = "login";
    return await HttpService.post(loginEndpoint, payload);
  };
  register = async (credentials) => {
    const registerEndpoint = "register";
    return await HttpService.post(registerEndpoint, credentials);
  };
  logout = async (access_token) => {
    const logoutEndpoint = "logout";
    return await HttpService.post(logoutEndpoint, access_token);
  };

  forgotPassword = async (payload) => {
    const forgotPassword = "password-forgot";
    return await HttpService.post(forgotPassword, payload);
  };

  resetPassword = async (credentials) => {
    const resetPassword = "password-reset";
    return await HttpService.post(resetPassword, credentials);
  };

  getProfile = async () => {
    const getProfile = "me";
    return await HttpService.get(getProfile);
  };

  updateProfile = async (newInfo) => {
    const updateProfile = "updateme";
    return await HttpService.patch(updateProfile, newInfo);
  };

  get_users = async (payload) => {
    const itemGetEndpoint = "get_users";
    return await HttpService.post(itemGetEndpoint, payload);
  };

  insert_user = async (payload) => {
    const itemInsertEndpoint = "insert_user";
    return await HttpService.post(itemInsertEndpoint, payload);
  };

  update_user = async (payload) => {
    const itemUpdateEndpoint = "update_user";
    return await HttpService.post(itemUpdateEndpoint, payload);
  };

  delete_user = async (payload) => {
    const itemDeleteEndpoint = "delete_user";
    return await HttpService.post(itemDeleteEndpoint, payload);
  };
  get_sizes = async (payload) => {
    const itemGetEndpoint = "get_sizes";
    return await HttpService.post(itemGetEndpoint, payload);
  };
  insert_size = async (payload) => {
    const itemInsertEndpoint = "insert_size";
    return await HttpService.post(itemInsertEndpoint, payload);
  };
  update_size = async (payload) => {
    const itemUpdateEndpoint = "update_size";
    return await HttpService.post(itemUpdateEndpoint, payload);
  };
  delete_size = async (payload) => {
    const itemDeleteEndpoint = "delete_size";
    return await HttpService.post(itemDeleteEndpoint, payload);
  };
  get_services = async (payload) => {
    const itemGetEndpoint = "get_services";
    return await HttpService.post(itemGetEndpoint, payload);
  };
  insert_service = async (payload) => {
    const itemInsertEndpoint = "insert_service";
    return await HttpService.post(itemInsertEndpoint, payload);
  };
  update_service = async (payload) => {
    const itemUpdateEndpoint = "update_service";
    return await HttpService.post(itemUpdateEndpoint, payload);
  };
  delete_service = async (payload) => {
    const itemDeleteEndpoint = "delete_service";
    return await HttpService.post(itemDeleteEndpoint, payload);
  };
  get_parties = async (payload) => {
    const itemGetEndpoint = "get_parties";
    return await HttpService.post(itemGetEndpoint, payload);
  };
  insert_party = async (payload) => {
    const itemInsertEndpoint = "insert_party";
    return await HttpService.post(itemInsertEndpoint, payload);
  };
  update_party = async (payload) => {
    const itemUpdateEndpoint = "update_party";
    return await HttpService.post(itemUpdateEndpoint, payload);
  };
  delete_party = async (payload) => {
    const itemDeleteEndpoint = "delete_party";
    return await HttpService.post(itemDeleteEndpoint, payload);
  };
  get_pricelists = async (payload) => {
    const itemGetEndpoint = "get_pricelists";
    return await HttpService.post(itemGetEndpoint, payload);
  };
  insert_pricelist = async (payload) => {
    const itemInsertEndpoint = "insert_pricelist";
    return await HttpService.post(itemInsertEndpoint, payload);
  };
  update_pricelist = async (payload) => {
    const itemUpdateEndpoint = "update_pricelist";
    return await HttpService.post(itemUpdateEndpoint, payload);
  };
  delete_pricelist = async (payload) => {
    const itemDeleteEndpoint = "delete_pricelist";
    return await HttpService.post(itemDeleteEndpoint, payload);
  };
  get_cnv_rates = async (payload) => {
    const itemGetEndpoint = "get_cnv_rates";
    return await HttpService.post(itemGetEndpoint, payload);
  };
  insert_cnv_rate = async (payload) => {
    const itemInsertEndpoint = "insert_cnv_rate";
    return await HttpService.post(itemInsertEndpoint, payload);
  };
  update_cnv_rate = async (payload) => {
    const itemUpdateEndpoint = "update_cnv_rate";
    return await HttpService.post(itemUpdateEndpoint, payload);
  };
  delete_cnv_rate = async (payload) => {
    const itemDeleteEndpoint = "delete_cnv_rate";
    return await HttpService.post(itemDeleteEndpoint, payload);
  };
  get_submissions = async (payload) => {
    const itemGetEndpoint = "get_submissions";
    return await HttpService.post(itemGetEndpoint, payload);
  };
  insert_submission = async (payload) => {
    const itemInsertEndpoint = "insert_submission";
    return await HttpService.post(itemInsertEndpoint, payload);
  };
  update_submission = async (payload) => {
    const itemUpdateEndpoint = "update_submission";
    return await HttpService.post(itemUpdateEndpoint, payload);
  };
  delete_submission = async (payload) => {
    const itemDeleteEndpoint = "delete_submission";
    return await HttpService.post(itemDeleteEndpoint, payload);
  };
  insert_result = async (payload) => {
    const itemInsertEndpoint = "insert_result";
    return await HttpService.post(itemInsertEndpoint, payload);
  };
  get_results = async (payload) => {
    const itemGetEndpoint = "get_results";
    return await HttpService.post(itemGetEndpoint, payload);
  };
  delete_result = async (payload) => {
    const itemDeleteEndpoint = "delete_result";
    return await HttpService.post(itemDeleteEndpoint, payload);
  };
  insert_reply = async (payload) => {
    const itemInsertEndpoint = "insert_reply";
    return await HttpService.post(itemInsertEndpoint, payload);
  };
  get_replies = async (payload) => {
    const itemGetEndpoint = "get_replies";
    return await HttpService.post(itemGetEndpoint, payload);
  };
  delete_reply = async (payload) => {
    const itemDeleteEndpoint = "delete_reply";
    return await HttpService.post(itemDeleteEndpoint, payload);
  };
  get_returns = async (payload) => {
    const itemGetEndpoint = "get_returns";
    return await HttpService.post(itemGetEndpoint, payload);
  };
  insert_return = async (payload) => {
    const itemInsertEndpoint = "insert_return";
    return await HttpService.post(itemInsertEndpoint, payload);
  };
  delete_return = async (payload) => {
    const itemDeleteEndpoint = "delete_return";
    return await HttpService.post(itemDeleteEndpoint, payload);
  };
  insert_bill = async (payload) => {
    const itemInsertEndpoint = "insert_bill";
    return await HttpService.post(itemInsertEndpoint, payload);
  };
  get_bills = async (payload) => {
    const itemGetEndpoint = "get_bills";
    return await HttpService.post(itemGetEndpoint, payload);
  };
  update_bill = async (payload) => {
    const itemUpdateEndpoint = "update_bill";
    return await HttpService.post(itemUpdateEndpoint, payload);
  };
  delete_bill = async (payload) => {
    const itemDeleteEndpoint = "delete_bill";
    return await HttpService.post(itemDeleteEndpoint, payload);
  };
  get_updates = async (payload) => {
    const itemGetEndpoint = "get_updates";
    return await HttpService.post(itemGetEndpoint, payload);
  };
  dashboard_statistics = async (payload) => {
    const itemGetEndpoint = "dashboard_statistics";
    return await HttpService.post(itemGetEndpoint, payload);
  };
  get_search_submissions = async (payload) => {
    const itemGetEndpoint = "get_search_submissions";
    return await HttpService.post(itemGetEndpoint, payload);
  };
  get_search_history = async (payload) => {
    const itemGetEndpoint = "get_search_history";
    return await HttpService.post(itemGetEndpoint, payload);
  };
  processBillingData = async (payload) => {
    const itemGetEndpoint = "processBillingData";
    return await HttpService.post(itemGetEndpoint, payload);
  };
  send_mail = async (payload) => {
    const itemGetEndpoint = "send_mail";
    return await HttpService.post(itemGetEndpoint, payload);
  };
  ungraded_submit_return = async (payload) => {
    const itemGetEndpoint = "ungraded_submit_return";
    return await HttpService.post(itemGetEndpoint, payload);
  };
  update_profile = async (payload) => {
    const itemGetEndpoint = "update_profile";
    return await HttpService.post(itemGetEndpoint, payload);
  };
  get_credit_notes = async (payload) => {
    const itemGetEndpoint = "get_credit_notes";
    return await HttpService.post(itemGetEndpoint, payload);
  };
  insert_credit_note = async (payload) => {
    const itemInsertEndpoint = "insert_credit_note";
    return await HttpService.post(itemInsertEndpoint, payload);
  };
  update_credit_note = async (payload) => {
    const itemUpdateEndpoint = "update_credit_note";
    return await HttpService.post(itemUpdateEndpoint, payload);
  };
  delete_credit_note = async (payload) => {
    const itemDeleteEndpoint = "delete_credit_note";
    return await HttpService.post(itemDeleteEndpoint, payload);
  };
  returns_ai_search = async (payload) => {
    const itemGetEndpoint = "returns_ai_search";
    return await HttpService.post(itemGetEndpoint, payload);
  };
}

export default new AuthService();
